import React from 'react';
import PropTypes from 'prop-types';

const FormGroup = ({ children, label, id, type }) => {
    return (
        <div className="form-input">
            <label htmlFor={id}>{label}</label>
            {type === 'radio' ? (
                <div className="radio">{children}</div>
            ) : (
                children
            )}
        </div>
    );
};

FormGroup.propTypes = {
    children: PropTypes.node,
    label: PropTypes.string,
    id: PropTypes.string,
    type: PropTypes.string
};

export default FormGroup;
